import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { PageHeader } from 'antd';
import { PAGE_DESC } from '../../config/constants';
import { wrapStyle } from './style';

class MyPage extends Component {
	render() {
		return (
			<div>
				<PageHeader
					title={PAGE_DESC.mypage.title}
					subTitle={PAGE_DESC.mypage.desc}
				/>
				<div style={wrapStyle}>
					<Link to="/mypage/resetpw">Reset Password</Link>
				</div>
			</div>
		);
	}
}

export default MyPage;
